// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da

import {
  FILEUPLOAD_SET_LOADING,
} from './constants';

export function setLoading() {
  return {
    type: FILEUPLOAD_SET_LOADING,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case FILEUPLOAD_SET_LOADING:
      return {
        ...state,
        loadingFile:true,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/fileupload/redux/setLoading.js